import createAppInstance from '../app'

const app = createAppInstance()
app.mount('#app')
